import { Str_BeforeYesterday, Str_Yesterday } from "../language/string_res";
import { beforeDatePlus } from "./utils";

const dateFormatters = [
    {
        // 当天
        range: 24 * 60 * 60 * 1000,
        format(date: number) {
            const targetDate = new Date(date);
            return `${('0' + targetDate.getHours()).slice(-2)}:${(
                '0' + targetDate.getMinutes()
            ).slice(-2)}`;
        },
    },
    {
        // 昨天
        range: 48 * 60 * 60 * 1000,
        format() {
            return Str_Yesterday;
        },
    },
    {
        // 前天
        range: 72 * 60 * 60 * 1000,
        format() {
            return Str_BeforeYesterday;
        },
    },
    {
        range: Date.now(),
        format(date: number) {
            return new Date(date).toISOString().slice(0, 10);
        },
    },
];

export const beforeDate = (date?: number): string => {
    if (!date) {
        return ''
    }
    return beforeDatePlus(date)
};


export function secondsToHms(sec: number, format: string = 'hh:mm:ss', separator: string = ':') {
    // 向上取整到最近的秒
    var roundedSec = Math.ceil(sec);

    var hours = Math.floor(roundedSec / 3600);
    var minutes = Math.floor((roundedSec % 3600) / 60);
    var seconds = roundedSec % 60;

    // 格式化每个部分
    const formattedHours = hours.toString().padStart(2, '0');
    const formattedMinutes = minutes.toString().padStart(2, '0');
    const formattedSeconds = seconds.toString().padStart(2, '0');

    // 替换格式字符串中的占位符
    const parts = format.split(/(h+|m+|s+)/);
    let result = '';
    let i = 0;
    while (i < parts.length) {
        if (parts[i].match(/[hms]/)) {
            switch (parts[i]) {
                case 'h': case 'hh':
                    result += formattedHours;
                    break;
                case 'm': case 'mm':
                    result += formattedMinutes;
                    break;
                case 's': case 'ss':
                    result += formattedSeconds;
                    break;
            }
        } else {
            result += parts[i]; // 添加分隔符或其他非占位符文本
        }
        i++;
    }

    return result.replace(/:/g, separator); // 如果需要，可以在最后一步替换分隔符
}

export const formatTime = (secs:number) => {
    if (!secs && secs !== 0) return '00:00';
    
    const hrs = Math.floor(secs / 3600);
    const mins = Math.floor((secs % 3600) / 60);
    const secsPart = Math.floor(secs % 60);
    
    if (hrs > 0) {
      return `${hrs.toString().padStart(2, '0')}:${mins.toString().padStart(2, '0')}:${secsPart.toString().padStart(2, '0')}`;
    }
    return `${mins.toString().padStart(2, '0')}:${secsPart.toString().padStart(2, '0')}`;
  };
